import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/portalFunctionalities`;

export const ROUTE: RouteDefinition = `${baseRoute}/portalFunctionalities`;

export const URL = (): RouteDefinition => `${baseRoute}/portalFunctionalities`;
